export default __webpack_public_path__ + "static/media/jinkidjin.5a9622f7.svg";